import React from 'react'

import GridDefault from './gridDefault'
import ListDefault from './listDefault'
import GridVideo from './gridVideo'
import FeatureContainer from '../../../containers/feature'

const ProductList = ({
  items,
  currentSite,
  preferences,
  itemDecorator,
  muteVideo,
  isSqueezed,
  viewType,
  isHeroItem
}) => {
  const nextViewType = viewType || preferences.searchResultsViewType
  const videoMuted = preferences.searchVideoMuted

  if (nextViewType === 'grid') {
    if (currentSite === 'videohive') {
      return (
        <React.Fragment>
          <FeatureContainer name="!videoHiveNewItemCard">
            <GridVideo
              isHeroItem={isHeroItem}
              items={items}
              viewType={nextViewType}
              videoMuted={videoMuted}
              muteVideo={muteVideo}
              currentSite={currentSite}
              itemDecorator={itemDecorator}
            />
          </FeatureContainer>

          <FeatureContainer name="videoHiveNewItemCard">
            <GridDefault
              items={items}
              viewType={nextViewType}
              currentSite={currentSite}
              itemDecorator={itemDecorator}
              isSqueezed={isSqueezed}
            />
          </FeatureContainer>
        </React.Fragment>
      )
    } else {
      return (
        <GridDefault
          items={items}
          viewType={nextViewType}
          currentSite={currentSite}
          itemDecorator={itemDecorator}
          isSqueezed={isSqueezed}
        />
      )
    }
  } else {
    return (
      <ListDefault
        items={items}
        viewType={nextViewType}
        currentSite={currentSite}
        itemDecorator={itemDecorator}
        videoMuted={videoMuted}
        muteVideo={muteVideo}
        isSqueezed={isSqueezed}
      />
    )
  }
}

export default ProductList
